import { HomeIcon } from './HomeIcon';

/**
 * author: Google
 * id 5D085274-15B9-42EC-8CCE-2F94C5EC039C
 * name home
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home.svg
 * tags
 * - Home Automation 
 * - Places 
 */
export const HouseIcon = HomeIcon;
export default HouseIcon